var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { LogicalCategoryEnum } from '@onereach/billing-dto';
import { BaseApi } from '../baseApi';
export default class CustomerUsageApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = '/customer-usage';
        this.apiCursorPath = '/customer-usage/cursor';
        this.apiCursorPollingPath = '/customer-usage/cursor/polling';
        this.apiEventDetailsCursorPath = '/usage-event-details/cursor';
        this.apiUsageProcessingPath = '/usage-processing';
    }
    getAllTraffic(filters_1) {
        return __awaiter(this, arguments, void 0, function* (filters, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}`, params: filters }, apiParams));
        });
    }
    getAllTrafficCursor(filters_1) {
        return __awaiter(this, arguments, void 0, function* (filters, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiCursorPath}`, params: filters }, apiParams));
        });
    }
    getUsageEventDetailsByCursor(filters_1) {
        return __awaiter(this, arguments, void 0, function* (filters, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: this.apiEventDetailsCursorPath, params: filters }, apiParams));
        });
    }
    startAllTrafficCursorPolling(filters_1) {
        return __awaiter(this, arguments, void 0, function* (filters, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiCursorPollingPath}/fetch-init`, params: filters }, apiParams));
        });
    }
    allTrafficCursorPollingResultsChunksCount(jobId_1) {
        return __awaiter(this, arguments, void 0, function* (jobId, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiCursorPollingPath}/${jobId}/results/chunks` }, apiParams));
        });
    }
    allTrafficCursorPollingFetchResultChunk(jobId_1, chunk_1) {
        return __awaiter(this, arguments, void 0, function* (jobId, chunk, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiCursorPollingPath}/${jobId}/results/chunks/${chunk}` }, apiParams));
        });
    }
    getUsageTraffic(filters_1) {
        return __awaiter(this, arguments, void 0, function* (filters, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}/${LogicalCategoryEnum.USAGE}`, params: filters }, apiParams));
        });
    }
    getUsageTrafficCursor(filters_1) {
        return __awaiter(this, arguments, void 0, function* (filters, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiCursorPath}/${LogicalCategoryEnum.USAGE}`, params: filters }, apiParams));
        });
    }
    getIdentifiersTraffic(filters_1) {
        return __awaiter(this, arguments, void 0, function* (filters, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}/${LogicalCategoryEnum.IDENTIFIERS}`, params: filters }, apiParams));
        });
    }
    getIdentifiersTrafficCursor(filters_1) {
        return __awaiter(this, arguments, void 0, function* (filters, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiCursorPath}/${LogicalCategoryEnum.IDENTIFIERS}`, params: filters }, apiParams));
        });
    }
    getUsersTraffic(filters_1) {
        return __awaiter(this, arguments, void 0, function* (filters, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}/${LogicalCategoryEnum.USERS}`, params: filters }, apiParams));
        });
    }
    getUsersTrafficCursor(filters_1) {
        return __awaiter(this, arguments, void 0, function* (filters, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiCursorPath}/${LogicalCategoryEnum.USERS}`, params: filters }, apiParams));
        });
    }
    getStorageTraffic(filters_1) {
        return __awaiter(this, arguments, void 0, function* (filters, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}/${LogicalCategoryEnum.STORAGE}`, params: filters }, apiParams));
        });
    }
    getStorageTrafficCursor(filters_1) {
        return __awaiter(this, arguments, void 0, function* (filters, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiCursorPath}/${LogicalCategoryEnum.STORAGE}`, params: filters }, apiParams));
        });
    }
    getSessionsTraffic(filters_1) {
        return __awaiter(this, arguments, void 0, function* (filters, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: '/sessions', params: filters }, apiParams));
        });
    }
    recompileData(data_1) {
        return __awaiter(this, arguments, void 0, function* (data, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'POST', route: '/queue-builder/usage', data }, apiParams));
        });
    }
    countUsageQueueItems(data_1) {
        return __awaiter(this, arguments, void 0, function* (data, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'POST', route: '/queue-builder/usage/count', data }, apiParams));
        });
    }
    createUsageProcessingJob(filters_1) {
        return __awaiter(this, arguments, void 0, function* (filters, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'POST', route: `${this.apiUsageProcessingPath}/job`, data: filters }, apiParams));
        });
    }
    usageProcessingJobStatus(jobId_1) {
        return __awaiter(this, arguments, void 0, function* (jobId, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiUsageProcessingPath}/${jobId}/status` }, apiParams));
        });
    }
    usageProcessingResultsChunksCount(jobId_1) {
        return __awaiter(this, arguments, void 0, function* (jobId, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiUsageProcessingPath}/${jobId}/results/chunks` }, apiParams));
        });
    }
    usageProcessingFetchResultChunk(jobId_1, chunk_1) {
        return __awaiter(this, arguments, void 0, function* (jobId, chunk, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiUsageProcessingPath}/${jobId}/results/chunks/${chunk}` }, apiParams));
        });
    }
    startExportCsvData(filters) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'GET',
                route: `${this.apiBasePath}/csv/export-init`,
                params: filters,
            });
        });
    }
}
//# sourceMappingURL=index.js.map